if (!window.__buyNowButtonInit) {
  window.__buyNowButtonInit = true;

  const getShopifyRoot = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const setLoading = (button, loading) => {
    button.classList.toggle('loading', loading);
    const spinner = button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !loading);
    if (loading) {
      button.setAttribute('aria-disabled', 'true');
    } else {
      button.removeAttribute('aria-disabled');
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-buy-now]');
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    const form = button.closest('form');
    const variantId = form ? form.querySelector('[name="id"]')?.value : null;
    if (!variantId) return;

    const quantityInput = form.querySelector('[name="quantity"]');
    const quantity = quantityInput ? quantityInput.value : 1;

    setLoading(button, true);

    fetch(`${getShopifyRoot()}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ id: variantId, quantity: quantity }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status) {
          setLoading(button, false);
          return;
        }
        window.location.href = `${getShopifyRoot()}checkout`;
      })
      .catch(() => {
        setLoading(button, false);
      });
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      document.querySelectorAll('[data-buy-now]').forEach((button) => {
        if (event.data.variant === null || event.data.variant === undefined) return;
        button.disabled = event.data.variant.available === false;
      });
    });
  }
}
